<template>
    <div class="tabs">
        <slot :toggle="toggle" :active="active" />

        <transition name="fade">
            <slot name="items" :active="active" />
        </transition>
    </div>
</template>

<script>
export default {
    name: 'TabsComponent',

    props: {
        default: String
    },

    data: () => ({
        active: ''
    }),

    mounted() {
        this.active = this.default ? this.default : ''
    },

    methods: {
        toggle(name) {
            this.active = name
        },

        close() {
            this.active = ''
        },
    },
}
</script>



// WEBPACK FOOTER //
// Tabs.vue?0a6d56b1